import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

const client = createClient({
  projectId: 'axwknhfh',
  dataset: 'production',
  apiVersion: '2024-12-15',
  useCdn: true,
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => {
  if (!source) {
    console.warn('No source provided to urlFor');
    return null;
  }
  return builder.image(source);
};

export default client;
